<template>
	<UserPageLayout :loading="loading" :error="error">
		<div class="health">
			<div>
				<div>firebird.innerlife.io</div>
				<div>It seems I'm OK!</div>
				<div>{{ $formatDate(new Date()) }}</div>
			</div>
			<span>→</span>
			<div>
				<div>Gateway (France)</div>
				<div>IPv4 - {{ ipv4_gateway_status ? 'ok' : 'fail' }}</div>
				<div>IPv6 - {{ ipv6_gateway_status ? 'ok' : 'fail' }}</div>
			</div>
			<span>→</span>
			<div>
				<div>Internet</div>
				<div>IPv4 - {{ ipv4_internet_status ? 'ok' : 'fail' }}</div>
				<div>IPv6 - {{ ipv6_internet_status ? 'ok' : 'fail' }}</div>
			</div>
		</div>
	</UserPageLayout>
</template>

<script>
import UserPageLayout from './_PageLayout.vue'

export default {
	name: 'UserHealthCheck',
	components: {
		UserPageLayout
	},
	data() {
		return {
			loading: true,
			error: '',
			ipv4_gateway_status: false,
			ipv6_gateway_status: false,
			ipv4_internet_status: false,
			ipv6_internet_status: false
		}
	},
	async mounted() {
		await this.fetchHealthStatus()
	},
	methods: {
		async fetchHealthStatus() {
			this.loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}

			try {
				const response = await this.$api.post('/api/user/health', {
					authToken: authToken
				})

				this.ipv4_gateway_status = response.data.ipv4_gateway_status || false
				this.ipv6_gateway_status = response.data.ipv6_gateway_status || false
				this.ipv4_internet_status = response.data.ipv4_internet_status || false
				this.ipv6_internet_status = response.data.ipv6_internet_status || false
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while fetching health status.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped>
.health {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	flex-wrap: wrap;
	padding: 20px;
}

.health > div {
	padding: 15px;
	border: 1px solid #ddd;
	text-align: center;
	flex: 1;
	min-width: 200px;
}

</style>
